// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const getColumnHeaders = distanceColumnLabel => [
    {
        className: 'description',
        id: 'DESCRIPTION'
    },
    {
        className: 'amount',
        id: 'AMOUNT'
    },
    {
        className: 'distance',
        id: distanceColumnLabel
    },
    {
        className: 'comments',
        id: 'COMMENTS'
    }
];

const OtherCreditsPanelRowHeader = props =>
    <section className='other-credits-panel-row-header'>
        {
            getColumnHeaders(props.distanceColumnLabel).map(column =>
                <span
                    className={column.className}
                    key={column.id}
                >
                    <FormattedMessage id={column.id}/>
                </span>
            )
        }
    </section>;

OtherCreditsPanelRowHeader.displayName = 'OtherCreditsPanelRowHeader';

OtherCreditsPanelRowHeader.propTypes = {
    distanceColumnLabel: PropTypes.string.isRequired
};

export default OtherCreditsPanelRowHeader;



// WEBPACK FOOTER //
// ./src/claim/shared/components/other-credits-panel/other-credits-panel-row-header.js